const footerColumns = [
  {
    title: "解析栏目",
    links: ["真相还原", "动机分析", "利益链拆解", "关联人物图谱"],
  },
  {
    title: "热点榜单",
    links: ["实时热度榜", "舆情反转榜", "争议存续榜", "数据来源说明"],
  },
  {
    title: "关于本站",
    links: ["解析方法论", "信息核对流程", "更正与申诉", "联系方式"],
  },
];

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-site px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-base font-bold text-background-50">
                17
              </span>
              <span className="font-heading text-[17px] font-bold text-foreground-950">17黑料网</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
              我们只做一件事：把分散的热点线索拼回完整脉络。还原真相与动机链条，呈现全貌而非片段，帮你看清舆论场里的复杂博弈与真实走向。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["声明比对", "时间线复原", "股权追踪"].map((t) => (
                <span
                  key={t}
                  className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 17黑料网 · 本站内容为公开信息整理与结构化解析，仅供信息参考。
          </p>
          <div className="flex flex-wrap gap-5">
            {["免责声明", "隐私政策", "内容更正"].map((link) => (
              <a
                key={link}
                href="#top"
                className="cursor-pointer whitespace-nowrap text-xs text-foreground-600 transition-colors hover:text-primary-600"
              >
                {link}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}